import { createContext } from 'react'

export const InputParamsContext = createContext()
export const ParamOptionsContext = createContext()
